import Axios from "axios";

var aiBaseURL = (process.env.VUE_APP_API_URL || "https://api.arboran.com.br/api/")
  .replace(/\/api\/$/, "/ai-service/api/v1");
if (process.env.NODE_ENV === "development") {
  aiBaseURL = "http://localhost:8000/api/v1";
}

const aiHttp = Axios.create({
  baseURL: aiBaseURL
});

const local = JSON.parse(localStorage.getItem("user-token"));
if (local) {
  aiHttp.defaults.headers.common["Authorization"] = "bearer " + local.token;
}

aiHttp.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      localStorage.removeItem("user-token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

class AnnexService {
  // ── Gestão de documentos ─────────────────────────────────────────────────

  RequestUploadUrl(contaId, filename, sizeBytes, description, category) {
    return aiHttp({
      url: "/annexes/upload-url",
      data: {
        conta_id: contaId,
        filename: filename,
        size_bytes: sizeBytes,
        description: description,
        category: category
      },
      method: "POST"
    });
  }

  UploadToS3(uploadUrl, file) {
    return Axios.put(uploadUrl, file, {
      headers: { "Content-Type": file.type }
    });
  }

  ConfirmUpload(annexId) {
    return aiHttp({
      url: "/annexes/" + annexId + "/confirm",
      method: "POST"
    });
  }

  ListAnnexes(contaId) {
    return aiHttp({
      url: "/annexes",
      params: { conta_id: contaId },
      method: "GET"
    });
  }

  GetAnnex(annexId) {
    return aiHttp({
      url: "/annexes/" + annexId,
      method: "GET"
    });
  }

  GetDownloadUrl(annexId) {
    return aiHttp({
      url: "/annexes/" + annexId + "/download-url",
      method: "GET"
    });
  }

  UpdateAnnex(annexId, data) {
    return aiHttp({
      url: "/annexes/" + annexId,
      data: data,
      method: "PATCH"
    });
  }

  DeleteAnnex(annexId) {
    return aiHttp({
      url: "/annexes/" + annexId,
      method: "DELETE"
    });
  }

  ReprocessAnnex(annexId) {
    return aiHttp({
      url: "/annexes/" + annexId + "/reprocess",
      method: "POST"
    });
  }

  // ── Pergunta e resposta (RAG) ────────────────────────────────────────────

  AskQuestion(contaId, question) {
    return aiHttp({
      url: "/annexes/qa/ask",
      data: { conta_id: contaId, question: question },
      method: "POST"
    });
  }

  ListQaMessages(contaId) {
    return aiHttp({
      url: "/annexes/qa/messages",
      params: { conta_id: contaId },
      method: "GET"
    });
  }
}

export default new AnnexService();
